import { motion, useScroll, useTransform } from "framer-motion";
import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Play } from "lucide-react";
import VideoModal from "./VideoModal";

const Hero = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [isVideoOpen, setIsVideoOpen] = useState(false);
  
  const { scrollY } = useScroll();
  const y1 = useTransform(scrollY, [0, 500], [0, 200]);
  const buttonOpacity = useTransform(scrollY, [100, 500], [1, 0]);

  // Check for vid param on mount
  useEffect(() => {
    if (searchParams.get("vid") === "1") {
      setIsVideoOpen(true);
      // Remove the param from URL without reload
      searchParams.delete("vid");
      setSearchParams(searchParams, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  return (
    <>
      <section className="relative min-h-screen flex flex-col items-center justify-center bg-background overflow-hidden pt-8">
        <motion.div className="relative z-20 text-center px-6 max-w-4xl mx-auto" style={{ y: y1 }}>
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="font-funnel text-[3.5rem] tablet:text-8xl laptop:text-9xl desktop:text-9xl font-bold text-foreground mb-8 leading-[0.9] tracking-tight"
          >
            <span className="whitespace-nowrap">work your way,</span>
            <br />
            <span className="font-cormorant italic font-normal text-foreground">anywhere.</span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.5 }}
            className="text-lg tablet:text-xl text-muted-foreground mb-8 max-w-2xl mx-auto leading-relaxed"
          >
            Private, soundproof pods in the places you already are.
            <br />
            Bookable by the minute. Quiet, on demand.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.7 }}
            className="flex flex-col items-center justify-center gap-4"
            style={{ opacity: buttonOpacity }}
          >
            {/* Watch Video Button */}
            <button
              onClick={() => setIsVideoOpen(true)}
              className="flex items-center gap-2 px-6 py-3 bg-primary text-primary-foreground rounded-full font-medium text-base hover:shadow-md active:scale-95 transition-all"
            >
              <Play className="w-4 h-4" fill="currentColor" />
              Watch our video
            </button>

            <a href="#how-it-works" className="text-foreground font-medium text-base hover:opacity-70 transition-opacity">
              Scroll to learn more
            </a>

            {/* Animated Down Arrow */}
            <motion.div
              animate={{ y: [0, 10, 0] }}
              transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-foreground/60">
                <path d="M12 5v14M19 12l-7 7-7-7" />
              </svg>
            </motion.div>

          </motion.div>
        </motion.div>
      </section>

      <VideoModal isOpen={isVideoOpen} onClose={() => setIsVideoOpen(false)} />
    </>
  );
};

export default Hero;